import { content } from "../../config/content.js";

function renderGauge(value) {
  const circumference = 2 * Math.PI * 46;
  const offset = circumference - (value / 100) * circumference;

  return `
    <svg class="hero-panel__gauge" viewBox="0 0 112 112" aria-hidden="true">
      <circle class="hero-panel__gauge-bg" cx="56" cy="56" r="46"/>
      <circle
        class="hero-panel__gauge-fill"
        cx="56" cy="56" r="46"
        stroke-dasharray="${circumference}"
        stroke-dashoffset="${circumference}"
        style="--target-offset: ${offset}"
      />
    </svg>
  `;
}

function renderWave() {
  return `
    <svg class="hero-panel__wave" viewBox="0 0 200 48" preserveAspectRatio="none" aria-hidden="true">
      <path class="hero-panel__wave-area" d="M0,36 C20,28 40,40 60,32 S100,20 120,28 160,38 200,24 L200,48 L0,48 Z"/>
      <path class="hero-panel__wave-line" d="M0,36 C20,28 40,40 60,32 S100,20 120,28 160,38 200,24"/>
    </svg>
  `;
}

function bindPipelineAnimation(wrap, count) {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const fill = wrap.querySelector(".hero-panel__track-fill");
  const stages = [...wrap.querySelectorAll(".hero-panel__stage")];
  if (!fill || stages.length < 2) return;

  let current = 0;
  const apply = () => {
    stages.forEach((el, i) => {
      el.classList.toggle("is-lit", i <= current);
      el.classList.toggle("is-current", i === current);
    });
    // Track spans 8%..92% of the pipeline row; land the fill on the dot center
    const center = ((current + 0.5) / count) * 100;
    const width = Math.max(0, Math.min(100, ((center - 8) / 84) * 100));
    fill.style.width = `${width}%`;
  };

  apply();
  const step = () => {
    current = (current + 1) % count;
    apply();
    // Hold a beat longer on the final stage before looping
    setTimeout(step, current === count - 1 ? 2600 : 1500);
  };
  setTimeout(step, 1500);
}

export function createHeroDashboard() {
  const panel = content.hero.panel;
  const wrap = document.createElement("div");
  wrap.className = "hero-panel reveal";
  wrap.style.setProperty("--delay", "0.12s");
  const activeStage = Math.max(0, panel.pipeline.length - 2);

  wrap.innerHTML = `
    <div class="hero-panel__ambient" aria-hidden="true"></div>

    <header class="hero-panel__header">
      <span class="hero-panel__title">${panel.title}</span>
      <span class="hero-panel__status">
        <span class="hero-panel__status-dot"></span>
        ${panel.status}
      </span>
    </header>

    <div class="hero-panel__gauge-block">
      ${renderGauge(panel.gauge.value)}
      <div class="hero-panel__gauge-center">
        <span class="hero-panel__gauge-value">${panel.gauge.value}%</span>
        <span class="hero-panel__gauge-label">${panel.gauge.label}</span>
      </div>
    </div>

    <ul class="hero-panel__chips" aria-label="Tech capabilities">
      ${panel.capabilities
        .map((cap) => `<li class="hero-panel__chip">${cap}</li>`)
        .join("")}
    </ul>

    <div class="hero-panel__pipeline">
      <div class="hero-panel__track" aria-hidden="true">
        <span class="hero-panel__track-fill"></span>
      </div>
      <div class="hero-panel__stages">
        ${panel.pipeline
          .map(
            (stage, i) => `
          <span class="hero-panel__stage${i <= activeStage ? " is-lit" : ""}" style="--i: ${i}">
            <span class="hero-panel__stage-dot"></span>
            ${stage}
          </span>
        `
          )
          .join("")}
      </div>
    </div>

    <footer class="hero-panel__footer">
      <div class="hero-panel__wave-wrap">
        <span class="hero-panel__wave-label">${panel.waveLabel}</span>
        ${renderWave()}
      </div>
      <div class="hero-panel__meta">
        <div class="hero-panel__regions" aria-label="Regions">
          ${panel.regions
            .map(
              (code, i) =>
                `<span class="hero-panel__region${i < 2 ? " is-active" : ""}">${code}</span>`
            )
            .join("")}
        </div>
        <div class="hero-panel__stats">
          ${panel.stats
            .map(
              (s) => `
            <div class="hero-panel__stat">
              <span class="hero-panel__stat-value">${s.value}</span>
              <span class="hero-panel__stat-label">${s.label}</span>
            </div>
          `
            )
            .join("")}
        </div>
      </div>
    </footer>
  `;

  bindPipelineAnimation(wrap, panel.pipeline.length);
  return wrap;
}
